import React from "react";
import { Space, Tabs, Typography } from "antd";
import PaymentAuthorView from "./PaymentAuthorView";
import PendingPayments from "./PendingPayments";
import PaymentLess100 from "./PaymentLess100";
import PaymentNoVendorId from "./PaymentNoVendorId";
import PaymentUpdate from "./PaymentUpdate";
import PaymentReset from "./PaymentReset";

const { Title, Paragraph, Text } = Typography;

function Payment() {
  const tabItems = [
    {
      key: "v0",
      label: "1. นำรายได้เก่าที่ไม่ได้จ่ายมาคิด",
      children: <PaymentReset />,
    },
    {
      key: "v1",
      label: "2. รายได้ไม่มี Vendor Id",
      children: <PaymentNoVendorId />,
    },
    {
      key: "v2",
      label: "3. รายการสะสมต่ำกว่า 100 บาท",
      children: <PaymentLess100 />,
    },
    {
      key: "v3",
      label: "(optional) 4. รายได้แต่ละผู้เขียน",
      children: <PaymentAuthorView />,
    },
    {
      key: "v4",
      label: "5. รายการรอทำจ่าย",
      children: <PendingPayments />,
    },
    {
      key: "v5",
      label: "6. อัพเดตสถานะทำจ่ายสำเร็จ",
      children: <PaymentUpdate />,
    },
  ];

  return (
    <Space direction="vertical" size={12}>
      <Title level={5}>วิธีใช้</Title>
      <Text>0. เปิด Vendor ให้ครบที่สุดเท่าที่จะทำได้</Text>
      <Text>
        1. นำรายได้เก่าที่ไม่ได้จ่ายมาคิด
        จะดึงเอารายได้ที่จ่ายไม่สำเร็จกับรายได้ทบยอดของเดือนก่อนๆ(เฉพาะส่วนของ
        Hytexts)กลับมาทำจ่ายด้วย ซึ่งหากยังไม่มี Vendor ID หรือยอดรวมไม่ถึง 100
        บาท จะสามารถปรับสถานะกลับไปได้ในขั้นตอนที่ 2,3 ต่อไป
        ต้องทำหลังจากขั้นตอนที่ 6 ของรอบก่อนเสร็จแล้วเท่านั้น หากกดผิดสามารถ
        Undo Reset ล่าสุดได้
      </Text>
      <Text>
        2. ตรวจสอบรายการที่ไม่มี Vendor Id สามารถ Download
        ข้อมูลเพื่อนำไปวิเคราะห์ว่ายอดขายรอบหลังๆยังมีขาด VendorId หรือไม่
        หลังจากนั้นเปลี่ยนสถานะเป็น ข้อมูลผู้ขายไม่ครบ เพื่อให้ User รับทราบ
      </Text>
      <Text>
        3. ตรวจสอบรายการสะสมน้อยกว่า 100 บาท สามารถ Download ได้เช่นกัน
        หลังจากนั้นปรับสภานะเป็นทบต้นเพื่อเอาไปคิดในขั้นตอนต่อไป
      </Text>
      <Text>
        4. หากมีผู้ขายบางคนขอให้ทำจ่ายยอดค้างจากเดือนก่อนที่ไม่มี Vendor
        หรือให้ทำจ่ายยอดน้อยกว่า 100 บาทเลย สามารถใช้หน้า Optional
        เพื่อปรับรายการจ่ายแต่ละ Seller ได้
      </Text>
      <Text>
        5. นำข้อมูลหน้าทำจ่ายไปทำจ่าย
        ซึ่งข้อมูลนี้จะรวมรายการที่ทบต้นมาจากขั้นตอนที่ 3
        และรายการที่ปรับด้วยขั้นตอนที่ 4
      </Text>
      <Text>6. อัพเดตสถานะทำจ่ายที่สำเร็จ</Text>
      <Tabs
        defaultActiveKey="v0"
        destroyInactiveTabPane={true}
        items={tabItems}
      />
    </Space>
  );
}

export default Payment;
